export class SimpleLiquiditySource {
  public identifier: string;
  public readableName: string;
  public iconUrl: string;
}
